import { intranetContentPath } from '@gb-ticket/shared-types';
import { Loader2Icon } from 'lucide-react';
import { Link } from 'react-router';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDateTime } from '@/lib/format';
import { useIntranetOwnAcknowledgements } from '@/products/intranet/features/intranet/use-intranet-ack';

/** Confirmations the signed-in person already gave. Open duties stay on the home gadget. */
export function IntranetAcknowledgementsCard() {
  const confirmed = useIntranetOwnAcknowledgements(true);
  const items = confirmed.data?.items ?? [];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Meine Lesebestätigungen</CardTitle>
      </CardHeader>
      <CardContent>
        {confirmed.isPending ? (
          <p className="flex items-center gap-2 text-sm text-muted-foreground">
            <Loader2Icon className="size-4 animate-spin" aria-hidden />
            Lesebestätigungen werden geladen …
          </p>
        ) : confirmed.isError ? (
          <p role="alert" className="text-sm text-destructive">
            Die Lesebestätigungen konnten nicht geladen werden.
          </p>
        ) : items.length === 0 ? (
          <p className="text-sm text-muted-foreground">Noch keine Lesebestätigung.</p>
        ) : (
          <ul className="space-y-1">
            {items.map((item) => (
              <li key={item.id}>
                <Link
                  to={intranetContentPath({ kind: item.kind, slug: item.slug })}
                  className="flex min-h-11 items-center justify-between gap-3 rounded-md px-2 text-sm hover:bg-muted focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:outline-none"
                >
                  <span className="truncate font-medium">{item.title}</span>
                  <time className="shrink-0 text-muted-foreground" dateTime={item.acknowledgedAt}>
                    {formatDateTime(item.acknowledgedAt)}
                  </time>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
